(function() {
    'use strict';

    angular
        .module('atheer.services', [
        ]);
})();
